import React from "react";
import { useI18n } from "../i18n";
import { Award, Globe, Heart, ShieldCheck } from "lucide-react";

export default function About() {
  const { t } = useI18n();
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
      <p className="dams-brand-sub text-red-500 mb-3">DAMS Car Rental</p>
      <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight">Built for explorers. Trusted by thousands.</h1>
      <p className="text-gray-600 mt-5 max-w-2xl text-lg">
        From Santo Domingo's cobblestone streets to Punta Cana's palm-lined highways, DAMS has powered Dominican adventures since 2015. We obsess over clean cars, honest pricing, and friendly humans — so you can focus on the journey.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
        {[
          { icon: <Award size={22} />, t: "#1 in DR", d: "Top-rated rental fleet by 12,000+ verified renters." },
          { icon: <Globe size={22} />, t: "6 locations", d: "Across the Dominican Republic and the United States." },
          { icon: <ShieldCheck size={22} />, t: "Fully insured", d: "Every car is covered with comprehensive insurance." },
          { icon: <Heart size={22} />, t: "Local team", d: "Real people answering 24/7 — no chatbots, no scripts." },
        ].map((f, i) => (
          <div key={i} className="card-soft p-6">
            <div className="w-11 h-11 rounded-xl bg-red-50 text-red-600 flex items-center justify-center mb-3">{f.icon}</div>
            <h3 className="font-bold">{f.t}</h3>
            <p className="text-sm text-gray-600 mt-1">{f.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
